import type { MachineSetupRepository } from '../data/machine-setup-repository';

export class DeleteCustomMachineTypeUseCase {
  constructor(private readonly repository: MachineSetupRepository) {}

  async execute(key: string): Promise<{ isSuccess: boolean; errorMessage?: string }> {
    return this.repository.deleteCustomMachineType(key);
  }
}
